/**
 * Public webeditor API configuration.
 *
 * This app no longer relies on Vercel/Vite env vars for these values.
 * If you need to change them, edit this file.
 */

/** Base URL for webeditor "website" mount (no trailing slash). */
export const PUBLIC_API_BASE_URL =
  import.meta.env.VITE_API_ENDPOINT || "https://admin.coretechs.se/website";

/** Website.slug in webeditor for Casa de Planka. */
export const PUBLIC_WEBSITE_SLUG = import.meta.env.VITE_WEBSITE_SLUG || "lacasadeplanka";

